import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import ProjectTabNavigation from "components/tablink/projecttablink"
import { Card, CardBody } from "reactstrap"

class SetupMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    handleSelectChange = (e) => {
    this.props.history.push(e.target.value);
  };
    render() {
        const { helpmenu, isResponsive } = this.props;
        const currentPath = this.props.location.pathname;
        const navItems = [
            {
                id: 'description',
                label: 'Description',
                link: `/pre-construction/create-project/description/${this.props.match.params.projectId}`
            },
             {
                id: 'assign',
                label: 'Project Assign',
                link: `/pre-construction/create-project/assign/${this.props.match.params.projectId}`
            },
            {
                id: 'feature',
                label: 'Features',
                link: `/pre-construction/create-project/feature/${this.props.match.params.projectId}`
            },          
            {
                id: 'media',
                label: 'Documents',
                link: `/pre-construction/create-project/media/${this.props.match.params.projectId}`
            },
            {
                id: 'link',
                label: 'Document links',
                link: `/pre-construction/create-project/link/${this.props.match.params.projectId}`
            },
            {
                id: 'gallery',
                label: 'Gallery',
                link: `/pre-construction/create-project/gallery/${this.props.match.params.projectId}`
            },
            {
                id: 'contact',
                label: 'Contacts',
                link: `/pre-construction/create-project/contact/${this.props.match.params.projectId}`
            }
        ];
        return (
            <React.Fragment>
                {isResponsive ? (
                    <Card className="mb-4">
                        <CardBody>
                            <h6>Select Menu</h6>
                             <select
                                className="form-select mb-3"
                                value={currentPath}
                                onChange={this.handleSelectChange}
                            >
                                {navItems.map((item) => (
                                <option key={item.id} value={item.link}>
                                    {item.label}
                                </option>
                                ))}
                            </select>
                        </CardBody>
                    </Card>
                ):(
                     <ProjectTabNavigation navItems={navItems} />
                )}
               

                
               
            </React.Fragment>
        )
    }
}
SetupMenu.propTypes = {
    match: PropTypes.object,
    helpmenu:PropTypes.object,
    history:PropTypes.object,
    isResponsive:PropTypes.object,
    location:PropTypes.object
}
export default withRouter(SetupMenu)
